import { render, staticRenderFns } from "./MerWithdrawInfo.vue?vue&type=template&id=4393b23f&scoped=true&"
import script from "./MerWithdrawInfo.vue?vue&type=script&lang=js&"
export * from "./MerWithdrawInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393b23f",
  null
  
)

export default component.exports